import { SEO } from '@carouselgg/nexus/seo'
import { Hero } from '../sections/Hero'
import { Problems } from '../sections/Problems'
import { Scoring } from '../sections/Scoring'
import { Product } from '../sections/Product'
import { Audiences } from '../sections/Audiences'
import { HowItWorks } from '../sections/HowItWorks'
import { LatestNews } from '../sections/LatestNews'
import { CTA } from '../sections/CTA'
import { SectionBoundary } from '../sections/SectionBoundary'

/**
 * Marketing homepage at `/`.
 *
 * Order is deliberate: the Trust Score proof used to sit fourth, ~2,600px down,
 * behind three sections of problem statement. It is the wedge, so it now lands
 * third, on the first inverted band, and the product itself — which the page
 * previously never showed at all — lands immediately after.
 *
 * Bands alternate tone and mirror their diagonal cut so the page does not read
 * as one uniform column. `Features`, `Platforms` and `Community` were absorbed
 * into Product, Audiences and CTA respectively.
 */
export function LoggedOutHome() {
  return (
    <>
      <SEO
        title="Carousel — Esports for everyone."
        description="Organized amateur esports leagues and tournaments at every skill level. Play a full season against teams at your own Elo, with verified identity and a Trust Score that keeps smurfs out of your bracket."
      />
      {/* Each band is isolated: one section failing to render costs that band,
          not the whole front door. See SectionBoundary. */}
      <SectionBoundary name="hero"><Hero /></SectionBoundary>
      <SectionBoundary name="problems"><Problems /></SectionBoundary>
      <SectionBoundary name="scoring"><Scoring /></SectionBoundary>
      <SectionBoundary name="product"><Product /></SectionBoundary>
      <SectionBoundary name="audiences"><Audiences /></SectionBoundary>
      <SectionBoundary name="how-it-works"><HowItWorks /></SectionBoundary>
      <SectionBoundary name="latest-news"><LatestNews /></SectionBoundary>
      <SectionBoundary name="cta"><CTA /></SectionBoundary>
    </>
  )
}
